import { render, staticRenderFns } from "./planSchemeTable.vue?vue&type=template&id=89b6e368"
import script from "./planSchemeTable.vue?vue&type=script&lang=js"
export * from "./planSchemeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports